import React from "react";
import { Navigate } from "react-router-dom";

/**
 * PermissionRoute
 * Protects a route based on user permissions.
 * If permission not allowed → redirects to /unauthorized
 * If allowed → renders the component
 */
const PermissionRoute = ({
  permissions,
  requiredPermission,
  children,
  showMessage = false,
}) => {
  const hasPermission = permissions?.includes(requiredPermission);

  // Define the background style object
  const unauthorizedBackgroundStyle = {
    backgroundImage: `url("/static/media/bg.055d610d01aba13ca82a.png")`,
    backgroundSize: "cover", // Optional: ensures the image covers the area
    backgroundPosition: "center", // Optional: centers the image
  };

  if (!hasPermission) {
    if (showMessage) {
      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-4"
          style={unauthorizedBackgroundStyle}
        >
          <div className="border border-gray-300 rounded-md p-4 bg-red-50 shadow-md">
            <div className="text-gray-400 text-lg font-mono whitespace-pre-wrap">
              <span>
                Access denied: You are not assigned this permission{" "}
                {requiredPermission}
              </span>
            </div>
          </div>
          <button
            onClick={() => window.history.back()}
            className="mt-6 border border-red-400 text-red-400 hover:bg-red-50 transition px-6 py-2 rounded-full text-sm font-medium"
          >
            Go Back
          </button>
        </div>
      );
    }

    // Default redirect
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};

export default PermissionRoute;
